import { useEffect } from "react";
import { MarketType } from "../types";

const GTM_ID = "GTM-KW4CR7N";
const SCRIPT_ID = "gtm-script";

/** Injects Google Tag Manager once for the Japan market. */
export default function useGoogleTagManagerJP(market: MarketType | null) {
  useEffect(() => {
    if (market !== "JP" || document.getElementById(SCRIPT_ID)) return;

    const script = document.createElement("script");
    script.id = SCRIPT_ID;
    script.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${GTM_ID}');
    `;

    document.head.appendChild(script);
  }, [market]);
}
